import { Skeleton } from "@circleco/compass/components/Skeleton";

import { Comments } from "@/react/components/CommentsCompass";

export const PostSkeleton = () => (
  <div className="flex flex-col gap-6" aria-busy="true" aria-live="polite">
    <div className="flex items-center gap-3">
      <Skeleton shape="pill" className="size-10" />
      <div className="flex flex-col gap-2">
        <Skeleton className="h-3.5 w-32" />
        <Skeleton className="h-3 w-20" />
      </div>
    </div>
    <div className="flex flex-col gap-3">
      <Skeleton className="h-6 w-3/4" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-11/12" />
      <Skeleton className="h-4 w-5/6" />
    </div>
    <Skeleton shape="square" className="h-56 w-full" />
    <div className="flex flex-col gap-3">
      <Skeleton className="h-4 w-2/3" />
      <Skeleton className="h-4 w-1/2" />
    </div>
    <div className="flex items-center gap-3 border-t pt-4">
      <Skeleton shape="pill" className="h-8 w-20" />
      <Skeleton shape="pill" className="h-8 w-20" />
      <Skeleton shape="pill" className="h-8 w-20" />
    </div>
    <Comments.CollapsibleComposerSkeleton />
  </div>
);
